import React from 'react';

function InstructionsContainer() {
  return (
    <div className="instructions-container" id="instructionsContainer">
      <div className="chat-instructions">
        <h4>How to Find Your Perfect Movie</h4>
        <p>Simply type your request in the chat to get personalized movie recommendations. Try these examples:</p>
        <ul>
          <li>Horror from the 90s</li>
          <li>Comedy with Robert De Niro</li>
          <li>Brad Pitt movies</li>
          <li>Drama movies</li>
          <li>90s movies</li>
          <li>Directed by Christopher Nolan</li>
        </ul>
        <p className="instruction-tip">For best results, keep your request simple and focused on one category at a time.</p>
      </div>
    </div>
  );
}

export default InstructionsContainer;
